import unconfiguredImageUrlBuilder from "@sanity/image-url";

export const defaultQuality = 80;

export const imageUrlBuilder = unconfiguredImageUrlBuilder()
  .projectId(process.env.GATSBY_SANITY_PROJECT_ID!)
  .dataset(process.env.GATSBY_SANITY_DATASET!)
  .auto("format")
  .quality(defaultQuality);
